import React, { useEffect, useState } from "react";
import { TextField, Button } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

import "./style.css";
import { request } from "../requests";

function App({ setSignedIn, signedIn }) {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [disabledLogin, setDisabledLogin] = useState(true);

  // Signin the user
  const signin = (event) => {
    event.preventDefault();
    setLoading(true);
    setError(false);

    request({
      type: "login",
      method: "post",
      data: { email: login, password },
    })
      .then(({ data: { token, name }, error }) => {
        setLoading(false);
        if (!error && token && name) {
          setSignedIn({ token, name });
        }
      })
      .catch(({ message }) => {
        setError(message);
        setLoading(false);
      });

    return false;
  };

  // Redirect users once loggedin
  useEffect(() => {
    if (signedIn === true) {
      history.push("/players");
    }
  }, [signedIn, history]);

  // Validate fields before submitting
  useEffect(() => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setDisabledLogin(
      !(re.test(String(login).toLowerCase()) && password.length > 0)
    );
  }, [login, password]);

  // Update the form fields
  const updateLogin = (e) => {
    setLogin(e.target.value);
  };
  const updatePassword = (e) => {
    setPassword(e.target.value);
  };

  return (
    <div className="App">
      <div className="Container">
        {loading && <CircularProgress />}
        {!loading && (
          <form class="Form" onSubmit={signin}>
            {error && <Alert severity="error">{error}</Alert>}
            <img className="logo" src="medias/circle.png" alt="" />
            <TextField
              type="email"
              label="Username"
              onChange={updateLogin}
            />
            <TextField
              label="Password"
              type="password"
              autoComplete="current-password"
              onChange={updatePassword}
            />
            <Button
              variant="contained"
              color="default"
              type="submit"
              disabled={disabledLogin}
            >
              Sign in
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}

export default App;
